var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"pa-2",attrs:{"row":""}},[_c('v-spacer'),_vm._l((_vm.skills),function(skill,index){return _c('skill-icon',{key:index,attrs:{"skill":skill}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }